import LinearProgressWithLabel from './LinearProgressWithLabel.component';

export default LinearProgressWithLabel;
